var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchiIcon2 = function SvgSearchiIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#4649B6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4649B6",
    d: "M7 7h18v18H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 22.225c-.29.29-.76.29-1.05 0l-4.2-4.2a4.571 4.571 0 0 1-2.85.975c-1.363 0-2.515-.472-3.459-1.415-.944-.944-1.416-2.098-1.416-3.46 0-1.363.472-2.516 1.416-3.46.944-.943 2.096-1.415 3.459-1.415s2.516.472 3.46 1.415c.943.944 1.415 2.098 1.415 3.46a4.571 4.571 0 0 1-.975 2.85l4.2 4.2c.29.29.29.76 0 1.05Zm-8.1-4.725c.938 0 1.735-.328 2.391-.984.656-.656.984-1.453.984-2.391s-.328-1.735-.984-2.391c-.656-.656-1.453-.984-2.391-.984s-1.735.328-2.391.984c-.656.656-.984 1.454-.984 2.391 0 .938.328 1.735.984 2.391.656.656 1.454.984 2.391.984Z",
    fill: "#DCDCEA"
  })));
};
export default SvgSearchiIcon2;